import { render, staticRenderFns } from "./PayControlDetails.vue?vue&type=template&id=059d9f82&"
import script from "./PayControlDetails.vue?vue&type=script&lang=js&"
export * from "./PayControlDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports